import schema from './schema';
import table from './table';
import fields from './fields';
import { camelToSnakeCase } from '../../utils/helpers';

const name = 'integrationClients';
const path = 'integration-clients';
const save = {
  name,
  path
};

const transformPayload = data => {
  const { allowedStudentFilters, ...rest } = data;
  const filterObject = {};

  if (allowedStudentFilters && Array.isArray(allowedStudentFilters)) {
    allowedStudentFilters.forEach(filter => {
      filterObject[camelToSnakeCase(filter)] = true;
    });
  }

  return {
    ...rest,
    allowed_student_filters: filterObject
  };
};

export default {
  restrict: 'integration_api_client',
  title: 'Integrations',
  createButton: 'Create Client',
  get: {
    name,
    path,
    transform: res => res.data.clients,
    defaultValue: []
  },
  create: { ...save, transform: transformPayload },
  edit: { ...save, method: 'patch', path: `${path}/:id`, transform: transformPayload },
  delete: { name, path: `${path}/:id` },
  table,
  modal: {
    title: 'Create Client',
    fields,
    schema
  }
};
